<template>
  <div>
    <div class="flex flex-col h-100vh">
      <BerkshireLine />
      <NoAccessCard class="flex-1">
        <template #icon>
          <q-icon name="coffee" color="tertiary" size="60px" />
        </template>
        <template #message>
          <div class="ba-h3">404 Page Not Found</div>
        </template>
        <template #action>
          <div class="flex justify-center">
            <BaseButton class="!max-w-250px" @click="toSafety">
              Return To Home
            </BaseButton>
          </div>
        </template>
      </NoAccessCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '~/stores/auth'
import { useNavigationStore } from '~/stores/navigation'
import { useHead } from '@unhead/vue'

const router = useRouter()
const AuthStore = useAuthStore()
const NavigationStore = useNavigationStore()

useHead({
  title: NavigationStore.isLoadingSetNavigationItems
    ? 'Berkshire Client Portal'
    : 'Not Found',
})

const toSafety = () => {
  if (
    AuthStore.firstPath &&
    AuthStore.firstPath !== router.currentRoute.value.path
  ) {
    router.push(AuthStore.firstPath)
    return
  }

  router.push({ name: 'login' })
}
</script>
